import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { useAppManager } from 'core/hooks';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionBanner, Paragraph, Box } from 'components';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import { FeaturedProjectsManager } from 'apps/home/community/featured/appManager';

const CommunityFeatured = observer(() => {
  const appManager = useAppManager(FeaturedProjectsManager, null);
  const featuredConnection = appManager.featuredProjectsConn;
  const featuredProjects = featuredConnection.arrayApp;

  return (
    <>
      <Header />
      <MainWrapper>
        <SectionBanner
          bannerId='get-project-featured'
          imageSrc='/assets/banners/005.svg'
          title='Want to get featured?'
          buttonText='Start public Project'
          linkName='home.newProject'
          paddingTop='xlarge'
          paddingBottom='xxlarge'
          eventCallback={() =>
            analytics.sendEvent(BANNER_ACTIONS.COMMUNITY_FEATURED)
          }
        >
          <Box>
            <Paragraph>
              <strong>Contribute to the Community</strong> with your product
              innovation.
            </Paragraph>
            <Paragraph>
              Start a Public Project to{' '}
              <strong>
                share files, documentation and information for how others can
                contribute{' '}
              </strong>
              and build upon your work.
            </Paragraph>
            <Paragraph>
              We can help{' '}
              <strong>promote your efforts to the community and beyond</strong>{' '}
              to advance its development.
            </Paragraph>
          </Box>
        </SectionBanner>
        {featuredConnection.loadingMore || featuredProjects.length > 0 ? (
          <CardSection
            invisible={appManager.loading}
            title='Featured Projects'
            subTitle={' '}
            isOwnProfile={false}
            ownerName=''
            cardApp={featuredProjects}
            CardComponent={ProjectCard}
            noDataCardType='project'
            gridColumns={3}
            noSort
          />
        ) : null}
      </MainWrapper>
    </>
  );
});

CommunityFeatured.propTypes = {
  t: PropTypes.func,
};

export default withNamespaces()(CommunityFeatured);
